export default "__VITE_ASSET__CzcqPLJs__"